import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { createNotificationSlice } from './notification'
import { createUserSlice } from './user'
import { createProfessionsSlice } from './professions'
import { createThemeSlice } from './theme'

export const useBoundStore = create<ReturnType<typeof createUserSlice> & ReturnType<typeof createNotificationSlice> &
ReturnType<typeof createProfessionsSlice> & ReturnType<typeof createThemeSlice>>()(
  devtools(
    (...a) => ({
      ...createUserSlice(...a),
      ...createNotificationSlice(...a),
      ...createProfessionsSlice(...a),
      ...createThemeSlice(...a),
    }),
    { enabled: process.env.REACT_APP_ENV !== 'production' }
  )
)
